<template>
  <a-modal :visible="visible" :title="modalTitle" :okText="okText" :cancelText="cancelText" @ok="handleOk"
    @cancel="handleCancel" :width="800" :confirmLoading="loading">
    <div class="cropper-container">
      <div class="cropper-wrapper">
        <vue-cropper ref="cropper" :img="imgUrl" :outputSize="outputSize" :outputType="outputType" :info="false"
          :full="full" :canMove="canMove" :canMoveBox="canMoveBox" :fixed="fixed" :fixedNumber="fixedNumber"
          :fixedBox="fixedBox" :original="original" :autoCrop="autoCrop" :autoCropWidth="autoCropWidth"
          :autoCropHeight="autoCropHeight" :centerBox="centerBox" :high="high" @realTime="realTime"
          :class="{ 'scene1': scene === 'avatar' && isFirstStep }"></vue-cropper>
      </div>
      <div class="preview-wrapper">
        <div class="preview-title">预览区域</div>
        <div class="preview-img">
          <img :src="previewImg" :class="{ 'br50': scene === 'avatar' && isFirstStep }" />
        </div>
        <div v-if="scene === 'avatar'" class="preview-size">
          生成尺寸: {{ previewWidth }}×{{ previewHeight }}px
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import ossApi from '../../api/oss'
import OSS from 'ali-oss'
import { v1 as uuidv1 } from 'uuid'
import { VueCropper } from 'vue-cropper'

export default {
  name: 'ImageCropper',
  components: {
    VueCropper
  },
  props: {
    imgUrl: {
      type: String,
      required: true
    },
    // 裁剪场景 avatar 教师头像、免冠照裁剪  normal 未来可拓展组件用于剪裁场景
    scene: {
      type: String,
      default: 'normal'
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      outputSize: 1, // 裁剪生成图片的质量
      outputType: 'png', // 裁剪生成图片的格式
      full: true, // 是否输出原图比例的截图 true就会保持跟剪裁框大小一致 false会是剪裁框x系统屏幕缩放比
      canMove: true, // 上传图片是否可以移动
      canMoveBox: true, // 截图框能否拖动
      fixed: true, // 是否开启截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例
      fixedBox: true, // true不能调整选框大小 false能
      original: true, // 上传图片按照原始比例渲染
      autoCrop: true, // 是否默认生成截图框
      autoCropWidth: 320, // 默认生成截图框宽度
      autoCropHeight: 320, // 默认生成截图框高度
      centerBox: true, // 截图框是否被限制在图片里面
      high: true, // 是否按照设备的dpr 输出等比例图片
      previewImg: '', // 预览图片
      confirmLoading: false,
      isFirstStep: true, // 是否是剪裁头像
      previewWidth: 320,
      previewHeight: 320,
      loading: false, // 上传的loading
      basePic1: '', // 头像的base64
      basePic2: '', // 免冠照的base64
      url1: '', // 头像的url
      url2: '', // 免冠照的url
    }
  },
  computed: {
    modalTitle() {
      return this.scene === 'avatar' ? (this.isFirstStep ? '裁剪头像' : '剪裁正面免冠照片') : '图片裁剪'
    },
    okText() {
      return this.scene === 'avatar' && this.isFirstStep ? '下一步' : '确定'
    },
    cancelText() {
      return this.scene === 'avatar' && !this.isFirstStep ? '上一步' : '取消'
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.cropper && this.$refs.cropper.refresh()
        })
      } else {
        this.isFirstStep = true
      }
    }
  },
  methods: {
    // 实时预览
    realTime() {
      this.$refs.cropper.getCropData((data) => {
        if (this.scene == 'avatar') {
          if (this.isFirstStep) {
            this.resizeBase64(data, 320, 320).then(res => {
              this.basePic1 = res
              this.previewImg = res
              this.$forceUpdate()
            })
          } else {
            this.resizeBase64(data, 413, 626).then(res => {
              this.basePic2 = res
              this.previewImg = res
              this.$forceUpdate()
            })
          }
        }
      })
    },
    // 将base64文件缩放至预想的输出大小
    resizeBase64(base64, targetWidth, targetHeight) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = function () {
          // 创建Canvas
          const canvas = document.createElement('canvas');
          canvas.width = targetWidth;
          canvas.height = targetHeight;
          const ctx = canvas.getContext('2d');
          // 设置高质量缩放
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          // 绘制缩放后的图像
          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
          // 转换回Base64
          resolve(canvas.toDataURL('image/png'));
        };
        img.src = base64;
      });
    },
    // 将base64转为File用于上传OSS
    base64ToFile(base64, filename = 'png') {
      const arr = base64.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);

      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      // 先创建Blob再转为File
      const blob = new Blob([u8arr], { type: mime });
      return new File([blob], filename, { type: mime });
    },
    handleOk() {
      if (this.scene === 'avatar') {
        if (this.isFirstStep) {
          // 头像场景第一步，切换到第二步
          this.isFirstStep = false
          this.fixedNumber = [413, 626]
          this.autoCropWidth = 413
          this.autoCropHeight = 626
          this.previewWidth = 413
          this.previewHeight = 626
          // 重新渲染预览 用$nextTick不生效
          setTimeout(() => {
            this.realTime()
          }, 50)
        } else {
          this.loading = true
          const file1 = this.base64ToFile(this.basePic1)
          const file2 = this.base64ToFile(this.basePic2)
          Promise.all([this.uploadFile(file1, 1), this.uploadFile(file2, 2)]).then(res => {
            this.initStep1()
            // console.log('都完成了', res, this.url1, this.url2)
            this.$emit('ok', this.url1, this.url2)
          })
        }
      }
    },
    handleCancel(e) {
      // 右上角x的e.target.type为undefined,点击直接关闭，
      if (!e.target.type) this.$emit('cancel')
      if (this.scene === 'avatar') {
        if (this.isFirstStep) {
          this.$emit('cancel')
        } else {
          this.initStep1()
          setTimeout(() => {
            this.realTime()
          }, 50)
        }
      }
    },
    initStep1() {
      this.isFirstStep = true
      this.fixedNumber = [1, 1]
      this.autoCropWidth = 320
      this.autoCropHeight = 320
      this.previewWidth = 320
      this.previewHeight = 320
    },
    // 上传步骤
    uploadFile(file, type) {
      this.loading = true
      return new Promise((resolve, reject) => {
        let self = this
        this.getStsToken().then((res) => {
          let fileName = file && file.name ? file.name.split('.') : ['jpg']
          let storeAs = this.getFileUrl(fileName[fileName.length - 1])
          let client = new OSS({
            accessKeyId: res.accessKeyId,
            accessKeySecret: res.accessKeySecret,
            stsToken: res.securityToken,
            bucket: 'after-class',
            region: 'oss-cn-hangzhou',
          })
          //storeAs表示上传的object name , file表示上传的文件
          client.multipartUpload(storeAs, file, {
            parallel: 4,
            partSize: 1024 * 1024,
          }).then(function (result) {
            let url = window.globalConfig.fileUrl + result.name
            if (type == 1) {
              self.url1 = url
            } else {
              self.url2 = url
            }
            resolve(url)
          }).catch(function (err) {
            console.error('文件上传失败', err)
            self.$message.error(
              '文件上传失败:"' + err.message + '" 请重新尝试上传。'
            )
            reject()
          }).finally(() => {
            self.loading = false
          })
        })
      })
    },
    //获取OSS token
    getStsToken() {
      let tempStsToken = this.$ls.get('stsToken')
      let promise = new Promise((resolve, reject) => {
        if (tempStsToken) {
          let tempDate = new Date(tempStsToken.expiration)
          let tempNowDate = new Date()
          if (tempNowDate.getTime() > tempDate.getTime()) {
            ossApi.getOssStsToken().then((res) => {
              //把stsToken放入对应的缓存里
              this.$ls.set('stsToken', res.stsToken)
              resolve(res.stsToken)
            })
          } else {
            resolve(tempStsToken)
          }
        } else {
          ossApi.getOssStsToken().then((res) => {
            //把stsToken放入对应的缓存里
            this.$ls.set('stsToken', res.stsToken)
            resolve(res.stsToken)
          })
        }
      })
      return promise
    },
    getFileUrl(fileType) {
      return `${this.ossType}/${this.getUuid()}.${fileType}`
    },
    getUuid() {
      return uuidv1().replace(/-/g, '')
    },
  }
}
</script>

<style scoped lang="less">
.cropper-container {
  display: flex;
  justify-content: space-between;
  height: 500px;
}

.cropper-wrapper {
  width: 620px;
  height: 100%;
  margin-right: 12px;
}

.preview-wrapper {
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview-title {
  margin: 20px 0 100px;
  font-weight: bold;
}

.preview-img {
  width: 120px;
  max-height: 300px;

  img {
    max-width: 120px;
    width: 100%;
    object-fit: cover;
  }
}

.br50 {
  border-radius: 50%;
}

.preview-size {
  text-align: center;
  color: #888;
  font-size: 14px;
  margin-top: 20px;
}

.scene1 {
  ::v-deep .cropper-view-box {
    border-radius: 50% !important;
  }

  ::v-deep .cropper-face {
    background-color: transparent;
  }
}
</style>